import React, { useState, useEffect } from 'react';
import BookService from '../../services/BookService';

const LogsDisplay = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isLogsVisible, setIsLogsVisible] = useState(false);

  const formatDate = (date) => date.toISOString().split('T')[0];

  const fetchLogs = async (customStartDate, customEndDate) => {
    const sDate = customStartDate || startDate;
    const eDate = customEndDate || endDate;

    if (!sDate || !eDate) {
      alert('Please provide both start and end dates.');
      return;
    }

    try {
      setLoading(true);
      const logsResponse = await BookService.getLogs({
        startDate: sDate,
        endDate: eDate,
      });
      setLogs(logsResponse.data);
      setIsLogsVisible(true);
    } catch (error) {
      console.error('Error fetching logs:', error);
      setLogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setDate(today.getDate() - 30);

    const formattedEndDate = formatDate(today);
    const formattedStartDate = formatDate(lastMonth);

    setStartDate(formattedStartDate);
    setEndDate(formattedEndDate);

    fetchLogs(formattedStartDate, formattedEndDate);
  }, []);

  const clearLogs = () => {
    setLogs([]);
    setStartDate('');
    setEndDate('');
    setIsLogsVisible(false);
  };

  return (
    <>
      <div className="max-w-3xl mx-auto mt-8 bg-white shadow-md rounded-lg p-6">
        {/* Title */}
        <h2 className="text-xl font-bold text-gray-800 mb-6 text-center">
          Logs Viewer
        </h2>

        {/* Dates row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block text-gray-700 font-semibold mb-2">
              From Date
            </label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-semibold mb-2">
              To Date
            </label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="flex flex-col md:flex-row gap-4 justify-center mb-6">
          <button
            onClick={() => fetchLogs()}
            className="bg-blue-600 text-white px-6 py-2 rounded font-semibold hover:bg-blue-700 transition"
          >
            Fetch Logs
          </button>

          <button
            onClick={clearLogs}
            className="bg-gray-500 text-white px-6 py-2 rounded font-semibold hover:bg-gray-600 transition"
          >
            Clear & Hide
          </button>
        </div>
      </div>
      {/* Logs Display */}
      <div className="w-full mx-auto mt-8 bg-white shadow-md rounded-lg p-6">
        {isLogsVisible && (
          <div className="mt-4">
            {loading ? (
              <p className="text-center text-gray-600">
                Loading logs...
              </p>
            ) : logs.length > 0 ? (
              <div className="h-96 overflow-y-auto border border-gray-200 rounded-lg bg-gray-50 p-4">
                {logs.map((log, index) => (
                  <div
                    key={index}
                    className="text-sm text-gray-700 mb-2 border-b pb-1"
                  >
                    {log}
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-gray-500">
                No logs available for the selected date range.
              </p>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default LogsDisplay;
